import { PartialType } from '../../../../utils';
import { CreateHourlyInsuranceFeeDto } from './create-hourly-insurance-fee.dto';
export class UpdateHourlyInsuranceFeeDto extends PartialType(CreateHourlyInsuranceFeeDto) {
}
